export const LOAD_REPORTING_AJAX_SUCCESS = "LOAD_REPORTING_AJAX_SUCCESS";
export const SAVE_REPORTING_SEARCH_CRITERIA = "SAVE_REPORTING_SEARCH_CRITERIA";
export const EXPORT_REPORT_AJAX_SUCCESS = "EXPORT_REPORT_AJAX_SUCCESS";
